import {StatusWayPointSingleVoyage} from "@containers/singleVoyage/types/point";

export const getPointLabelKeyStatusSingleVoyage = (status:StatusWayPointSingleVoyage) => {
    switch (status) {
        case "PLANNED": return 'singleVoyage.pointStatuses.planned'
        case "COMPLETED": return 'singleVoyage.pointStatuses.completed'
        case "SKIPPED": return 'singleVoyage.pointStatuses.skipped'
        case "IN_PROGRESS": return 'singleVoyage.pointStatuses.inProgress'
        case "DELETED": return 'singleVoyage.pointStatuses.deleted'
        case "PARTIAL_COMPLETED": return 'singleVoyage.pointStatuses.partialCompleted'
        default: return status
    }
}